/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/pt_PT';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Aceder ao bonito editor HTML"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Verificador de acessibilidade"
  },
  "action_to_take_b626a99a": {
    "message": "Ação a tomar:"
  },
  "add_8523c19b": {
    "message": "Adicionar"
  },
  "add_a_caption_2a915239": {
    "message": "Adicionar uma legenda"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Adicionar texto alternativo para a imagem"
  },
  "add_another_f4e50d57": {
    "message": "Adicionar outro"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Adicionar Legenda/Legendas"
  },
  "add_image_60b2de07": {
    "message": "Adicionar imagem"
  },
  "add_one_9e34a6f8": {
    "message": "Adicionar um!"
  },
  "additional_considerations_f3801683": {
    "message": "Considerações adicionais"
  },
  "address_applied_64269b0b": {
    "message": "Endereço aplicado"
  },
  "address_removed_fcb496e0": {
    "message": "Endereço removido"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Ligações adjacentes com o mesmo URL devem ser uma única ligação."
  },
  "aleph_f4ffd155": {
    "message": "Alef"
  },
  "align_11050992": {
    "message": "Alinhar"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Alinhamento e Listas"
  },
  "all_4321c3a1": {
    "message": "Todos"
  },
  "all_apps_a50dea49": {
    "message": "Todas as aplicações"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Permitir o descarregamento de multimédia"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Permitir o descarregamento da transcrição"
  },
  "alpha_15d59033": {
    "message": "Alfa"
  },
  "alphabetical_55b5b4e0": {
    "message": "Alfabético"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "O texto do atributo Alt não deve conter mais de 120 caracteres."
  },
  "alt_text_611fb322": {
    "message": "Texto Alt"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amálgama (Co-produto)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Ocorreu um erro ao ler o ficheiro"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Ocorreu um erro ao fazer uma solicitação de rede"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Ocorreu um erro ao carregar seu multimédia."
  },
  "and_7fcc2911": {
    "message": "E"
  },
  "angle_c5b4ec50": {
    "message": "Ângulo"
  },
  "announcement_fb4cb645": {
    "message": "Anúncio"
  },
  "announcement_list_da155734": {
    "message": "Lista de anúncio"
  },
  "announcements_a4b8ed4a": {
    "message": "Anúncios"
  },
  "apply_781a2546": {
    "message": "Aplicar"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Aplicar alterações a todas as instâncias deste Ícone de Criador de Ícones na Disciplina"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Aproxima-se do limite"
  },
  "approximately_e7965800": {
    "message": "Aproximadamente"
  },
  "apps_54d24a47": {
    "message": "Aplicativos"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Tem a certeza que deseja cancelar? As alterações que realizou não podem ser guardadas."
  },
  "arrows_464a3e54": {
    "message": "Setas"
  },
  "art_icon_8e1daad": {
    "message": "Ícone da Arte"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "A relação de aspeto será preservada"
  },
  "assignment_976578a8": {
    "message": "Tarefa"
  },
  "assignments_1e02582c": {
    "message": "Tarefas"
  },
  "asterisk_82255584": {
    "message": "Asterisco"
  },
  "attributes_963ba262": {
    "message": "Atributos"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Gravação de áudio e vídeo não suportada; por favor use um navegador diferente."
  },
  "audio_options_feb58e2c": {
    "message": "Opções áudio"
  },
  "audio_options_tray_33a90711": {
    "message": "Bandeja de opções áudio"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Leitor de áudio para { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "O conteúdo auto-salvamento existe. Você gostaria de carregar o conteúdo auto-salvamento em seu lugar?"
  },
  "available_folders_694d0436": {
    "message": "Pastas disponíveis"
  },
  "background_1bc88842": {
    "message": "Cor de fundo"
  },
  "backslash_b2d5442d": {
    "message": "Barra invertida"
  },
  "bar_ec63ed6": {
    "message": "Bar"
  },
  "basic_554cdc0a": {
    "message": "Básico"
  },
  "because_501841b": {
    "message": "Porque"
  },
  "below_81d4dceb": {
    "message": "Abaixo"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Grande Círculo"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Coeficiente Binomial"
  },
  "black_4cb01371": {
    "message": "Preto"
  },
  "blue_daf8fea9": {
    "message": "Azul"
  },
  "bold_applied_42d547b7": {
    "message": "Negrito aplicado"
  },
  "bold_removed_da474a5c": {
    "message": "Negrito removido"
  },
  "border_5b08b06d": {
    "message": "Fronteira"
  },
  "bottom_15a2a9be": {
    "message": "Inferior"
  },
  "bottom_third_5f5fec1d": {
    "message": "Terço inferior"
  },
  "bowtie_5f9629e4": {
    "message": "Bowtie"
  },
  "brick_f2656265": {
    "message": "Construir"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Cancelar"
  },
  "cap_product_3a5265a6": {
    "message": "Tampa Produto"
  },
  "caption_manager_aae0906f": {
    "message": "Gestor de legendas"
  },
  "center_align_e68d9997": {
    "message": "Alinhamento ao centro"
  },
  "centered_dot_64d5e378": {
    "message": "Ponto centrado"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Pontos Horizontais Centrados"
  },
  "change_alt_text_92654906": {
    "message": "Alterar texto alternativo"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Alterar a etiqueta de título para o parágrafo"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Alterar apenas o nível desta rubrica"
  },
  "change_text_color_1aecb912": {
    "message": "Mudar a cor do texto"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "As alterações serão aplicadas após guardar esta página."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "As alterações que realizou não podem ser guardadas."
  },
  "characters_9d897d1c": {
    "message": "Caracteres"
  },
  "characters_no_spaces_485e5367": {
    "message": "Caracteres (sem espaços)"
  },
  "check_accessibility_3c78211c": {
    "message": "Verificar Acessibilidade"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Verificar problemas de acessibilidade"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Ficheiro de legenda"
  },
  "choose_usage_rights_33683854": {
    "message": "Escolher direitos de utilização..."
  },
  "circle_484abe63": {
    "message": "Círculo"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "lista desordenada circular"
  },
  "clear_2084585f": {
    "message": "Limpar"
  },
  "clear_image_3213fe62": {
    "message": "Limpar imagem"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Clicar ou clicar com o shift para o editor html."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Clique para incorporar { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Clique para ocultar a pré-visualização"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Clique para inserir uma ligação no editor."
  },
  "click_to_show_preview_faa27051": {
    "message": "Clique para mostrar a pré-visualização"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Feche um menu ou diálogo. Também retorna para a área do editor"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Fechar Verificador de acessibilidade"
  },
  "close_d634289d": {
    "message": "Fechar"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "Fechar Atalhos de teclado modais"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "O ficheiro de legendagem deve ser inferior a { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Legendas/subtítulos"
  },
  "clubs_suit_c1ffedff": {
    "message": "Clubes (Fato)"
  },
  "collab_575ac7bc": {
    "message": "Colab"
  },
  "collaborations_5c56c15f": {
    "message": "Colaborações"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Recolher para ocultar { types }"
  },
  "color_a363e1b0": {
    "message": "Cor"
  },
  "color_contrast_4c418add": {
    "message": "Contraste de cor"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Relação de contraste de cor"
  },
  "color_picker_6b359edf": {
    "message": "Seletor de cores"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Seletor de Cores ({ colorName } selecionado)"
  },
  "color_popup_af39810f": {
    "message": "Popup de cor"
  },
  "column_e1ae5c64": {
    "message": "Coluna"
  },
  "column_group_1c062368": {
    "message": "Grupo de coluna"
  },
  "complex_numbers_a543d004": {
    "message": "Números complexos"
  },
  "computer_1d7dfa6f": {
    "message": "Computador"
  },
  "congruent_5a244acd": {
    "message": "Congruente"
  },
  "contains_311f37b7": {
    "message": "Contém"
  },
  "content_1440204b": {
    "message": "Conteúdo"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "O conteúdo do editor será alterado. Prima Cancelar para manter o conteúdo original."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Conteúdo ainda está a ser carregado, se você continuar, o mesmo não será incorporado corretamente."
  },
  "content_subtype_5ce35e88": {
    "message": "Subtipo de conteúdo"
  },
  "content_type_2cf90d95": {
    "message": "Tipo de conteúdo"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Continuar para o conteúdo do YouTube"
  },
  "coproduct_e7838082": {
    "message": "Co-produto"
  },
  "copyright_holder_66ee111": {
    "message": "Titular dos direitos de autor:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Não foi possível inserir conteúdo: Os itens \"{ itemType }\" não são actualmente suportados no Canvas."
  },
  "count_40eced3b": {
    "message": "Contagem"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 palavras}\n    one {1 palavras}\n  other {# palavras}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# itens carregados}\n  other {# itens carregados}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Documentos da disciplina"
  },
  "course_files_62deb8f8": {
    "message": "Ficheiros de disciplinas"
  },
  "course_files_a31f97fc": {
    "message": "Ficheiros de disciplina"
  },
  "course_images_f8511d04": {
    "message": "Imagens da disciplina"
  },
  "course_link_b369426": {
    "message": "Ligação da disciplina"
  },
  "course_links_b56959b9": {
    "message": "Ligações da disciplina"
  },
  "course_media_ec759ad": {
    "message": "Mídia da disciplina"
  },
  "course_navigation_dd035109": {
    "message": "Navegação da disciplina"
  },
  "create_icon_110d6463": {
    "message": "Criar Ícone"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Criar Ícone Criador de Ícones"
  },
  "creative_commons_license_725584ae": {
    "message": "Licença Creative Commons:"
  },
  "crop_image_41bf940c": {
    "message": "Cortar imagem"
  },
  "crop_image_807ebb08": {
    "message": "Cortar Imagem"
  },
  "cup_product_14174434": {
    "message": "Taça Produto"
  },
  "current_image_f16c249c": {
    "message": "Imagem atual"
  },
  "current_link_945a47ee": {
    "message": "Ligação atual"
  },
  "current_volume_level_c55ab825": {
    "message": "Nível volume corrente"
  },
  "custom_6979cd81": {
    "message": "Personalizadas"
  },
  "cyan_c1d5f68a": {
    "message": "Ciano"
  },
  "dagger_57e0f4e5": {
    "message": "Adaga"
  },
  "date_added_ed5ad465": {
    "message": "Data adicionada"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Ícone decorativo"
  },
  "decorative_image_fde98579": {
    "message": "Imagem decorativa"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Decorativo { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Diminuir Avanço"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Diminuir área de conteúdo avançado"
  },
  "deep_purple_bb3e2907": {
    "message": "Roxo Escuro"
  },
  "default_9db103d": {
    "message": "Padrão"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "lista desordenada com marcas por defeito"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "lista numérica ordenada por defeito"
  },
  "definite_integral_fe7ffed1": {
    "message": "Integral Definitivo"
  },
  "degree_symbol_4a823d5f": {
    "message": "Símbolo de Grau"
  },
  "delimiters_4db4840d": {
    "message": "Delimitadores"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Descrever o ícone)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Descrever o { TYPE })"
  },
  "description_436c48d7": {
    "message": "Descrição"
  },
  "details_98a31b68": {
    "message": "Detalhes"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Pontos diagonais"
  },
  "diamond_b8dfe7ae": {
    "message": "Diamante"
  },
  "diamonds_suit_526abaaf": {
    "message": "Diamantes (Fato)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Tipo de dimensão"
  },
  "directionality_26ae9e08": {
    "message": "Direcionalidade"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Editar diretamente LaTeX"
  },
  "disable_preview_222bdf72": {
    "message": "Pré-visualização de incapacitação"
  },
  "discussion_6719c51d": {
    "message": "Discussão"
  },
  "discussions_a5f96392": {
    "message": "Discussões"
  },
  "discussions_index_6c36ced": {
    "message": "Índice de discussões"
  },
  "disjoint_union_e74351a8": {
    "message": "União Desjunta"
  },
  "display_options_315aba85": {
    "message": "Opções de exibição"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Exibir ligação de texto (abre em uma nova guia)"
  },
  "div_applied_49ad83fc": {
    "message": "Div aplicado"
  },
  "div_removed_d13f8e17": {
    "message": "Div removido"
  },
  "division_sign_72190870": {
    "message": "Sinal de divisão"
  },
  "document_678cd7bf": {
    "message": "Documento"
  },
  "documents_81393201": {
    "message": "Documentos"
  },
  "done_54e3d4b6": {
    "message": "Feito"
  },
  "double_dagger_faf78681": {
    "message": "Adaga dupla"
  },
  "down_5831a426": {
    "message": "Para baixo"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Seta diagonal para baixo e esquerda"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Seta diagonal para baixo e direita"
  },
  "download_filename_2baae924": {
    "message": "Descarregar { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Seta para baixo"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Triângulo de Apontamento Descendente"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Arraste um ficheiro aqui"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Arraste e solte ou clique para navegar no seu computador"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Arraste a alça. Use as setas para cima e para baixo para redimensionar"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Data limite: Várias datas"
  },
  "due_when_7eed10c6": {
    "message": "Data limite: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Editar texto alt para este ícone, por exemplo"
  },
  "edit_c5fbea07": {
    "message": "Editar"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Editar ligação da disciplina"
  },
  "edit_equation_f5279959": {
    "message": "Editar Equação"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Editar Ícone do Criador de Ícones Existente"
  },
  "edit_icon_2c6b0e91": {
    "message": "Editar Ícone"
  },
  "edit_link_7f53bebb": {
    "message": "Editar ligação"
  },
  "editor_status_bar_653f44ee": {
    "message": "Barra de estado do editor"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Elemento a começar com { start }"
  },
  "embed_828fac4a": {
    "message": "Incluído"
  },
  "embed_code_314f1bd5": {
    "message": "Incorporar Código"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Incorporar conteúdo da ferramenta externa"
  },
  "embed_image_1080badc": {
    "message": "Incorporar imagem"
  },
  "embed_video_a97a64af": {
    "message": "Incorporar Vídeo"
  },
  "embedded_content_aaeb4d3d": {
    "message": "conteúdo incorporado"
  },
  "empty_set_91a92df4": {
    "message": "Conjunto Vazio"
  },
  "encircled_dot_8f5e51c": {
    "message": "Ponto Cercado"
  },
  "encircled_minus_72745096": {
    "message": "Cercado Menos"
  },
  "encircled_plus_36d8d104": {
    "message": "Cercado Mais"
  },
  "encircled_times_5700096d": {
    "message": "Tempos Cercados"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Ícone de engenharia"
  },
  "english_icon_25bfe845": {
    "message": "Ícone inglês"
  },
  "enter_a_media_title_81b490ec": {
    "message": "Introduzir um título"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Digite pelo menos 3 caracteres para pesquisar"
  },
  "enter_replacement_text_17631bbc": {
    "message": "introduzir texto de substituição"
  },
  "enter_search_text_26cb4459": {
    "message": "introduzir texto de pesquisa"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (Variante)"
  },
  "equals_sign_c51bdc58": {
    "message": "Sinal de igualdade"
  },
  "equation_1c5ac93c": {
    "message": "Equação"
  },
  "equation_editor_39fbc3f1": {
    "message": "Editor de equações"
  },
  "equilibrium_6ff3040b": {
    "message": "Equilíbrio"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Classe de Equivalência"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Equivalente (Identidade)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Existe"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Sair em ecrã inteiro"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Expandir pré-visualização por defeito"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Expandir para ver { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Ligação externa"
  },
  "external_tool_frame_70b32473": {
    "message": "Estrutura externa da ferramenta"
  },
  "external_tools_6e77821": {
    "message": "Ferramentas externas"
  },
  "extra_large_b6cdf1ff": {
    "message": "Extra grande"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "Extra Grande ({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "Extra Pequeno"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Ícone extracurricular"
  },
  "f_function_fe422d65": {
    "message": "F (função)"
  },
  "fail_544e5dde": {
    "message": "FALHA"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Falha na obtenção do conteúdo do ficheiro"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Falha na recuperação de conteúdo de ferramenta externa"
  },
  "file_name_8fd421ff": {
    "message": "Nome do ficheiro"
  },
  "file_preview_21667a6e": {
    "message": "Pré-visualização do ficheiro"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Pré-visualização de ficheiro para { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Quota de armazenamento de ficheiros excedida"
  },
  "file_url_c12b64be": {
    "message": "URL do ficheiro"
  },
  "filename_file_icon_602eb5de": {
    "message": "{ filename } ícone do ficheiro"
  },
  "filename_image_preview_6cef8f26": {
    "message": "{ filename } visualização de imagem"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "{ filename } visualização de texto"
  },
  "files_c300e900": {
    "message": "Ficheiros"
  },
  "files_index_af7c662b": {
    "message": "Índice de arquivos"
  },
  "find_8d605019": {
    "message": "Localizar"
  },
  "find_and_replace_6e345933": {
    "message": "Localizar e substituir"
  },
  "finish_bc343002": {
    "message": "Terminar"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Fixar hierarquia"
  },
  "flat_music_76d5a5c3": {
    "message": "Plano (Música)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Barra de ferramentas de opções de elementos de foco"
  },
  "folder_tree_fbab0726": {
    "message": "Árvore de pastas"
  },
  "for_all_b919f972": {
    "message": "Para todos"
  },
  "format_4247a9c5": {
    "message": "Formato"
  },
  "format_as_a_list_142210c3": {
    "message": "Formatar como uma lista"
  },
  "formatting_5b143aa8": {
    "message": "Formatação"
  },
  "forward_slash_3f90f35e": {
    "message": "Cortar para a frente"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Encontrado conteúdo auto-salvamento"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Foram encontrados { count, plural,\n     =0 {# resultados}\n    one {# resultado}\n  other {# resultados}\n}"
  },
  "fraction_41bac7af": {
    "message": "Fração"
  },
  "fullscreen_873bf53f": {
    "message": "Ecrã completo"
  },
  "gamma_1767928": {
    "message": "Gama"
  },
  "generating_preview_45b53be0": {
    "message": "A gerar visualização..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "As imagens em formato GIF/PNG maiores do que { size } KB não são atualmente suportadas."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Ir para a barra de menu do editor"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Ir para a barra de ferramenta do editor"
  },
  "grades_a61eba0a": {
    "message": "Classificações"
  },
  "graphics_text_bc9568bc": {
    "message": "Texto gráfico"
  },
  "greater_than_e98af662": {
    "message": "Maior do que"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Maior do que ou igual"
  },
  "greek_65c5b3f7": {
    "message": "Grego"
  },
  "green_15af4778": {
    "message": "Verde"
  },
  "grey_a55dceff": {
    "message": "Cinzento"
  },
  "group_documents_8bfd6ae6": {
    "message": "Agrupar Documentos"
  },
  "group_files_4324f3df": {
    "message": "Arquivos de grupo"
  },
  "group_files_82e5dcdb": {
    "message": "Ficheiros de grupo"
  },
  "group_images_98e0ac17": {
    "message": "Agrupar Imagens"
  },
  "group_isomorphism_45b1458c": {
    "message": "Isomorfismo de grupo"
  },
  "group_link_63e626b3": {
    "message": "Ligação de grupo"
  },
  "group_links_9493129e": {
    "message": "Ligações do grupo"
  },
  "group_media_2f3d128a": {
    "message": "Agrupar Meios de comunicação"
  },
  "group_navigation_99f191a": {
    "message": "Navegação do grupo"
  },
  "h_bar_bb94deae": {
    "message": "Bar H"
  },
  "hat_ea321e35": {
    "message": "Chapéu"
  },
  "header_column_f27433cb": {
    "message": "Coluna de cabeçalho"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Cabeçalho linha e coluna"
  },
  "header_row_f33eb169": {
    "message": "Linha de cabeçalho"
  },
  "heading_2_5b84eed2": {
    "message": "Cabeçalho 2"
  },
  "heading_3_2c83de44": {
    "message": "Cabeçalho 3"
  },
  "heading_4_b2e74be7": {
    "message": "Cabeçalho 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Título { h } aplicado"
  },
  "heading_h_removed_745f24a6": {
    "message": "Título { h } removido"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Os níveis de título não devem ser ignorados."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Título começando com { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Os títulos não devem conter mais de 120 caracteres."
  },
  "health_icon_8d292eb5": {
    "message": "Ícone de saúde"
  },
  "hearts_suit_e50e04ca": {
    "message": "Corações (Fato)"
  },
  "height_69b03e15": {
    "message": "Altura"
  },
  "hexagon_d8468e0d": {
    "message": "Hexágono"
  },
  "hide_description_bfb5502e": {
    "message": "Ocultar descrição"
  },
  "hide_title_description_caf092ef": {
    "message": "Ocultar descrição { title }"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Realçar um elemento para ativar a barra de ferramentas de opções de elementos"
  },
  "home_351838cd": {
    "message": "Início"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "Como solicitar e editar legendas?"
  },
  "html_code_editor_fd967a44": {
    "message": "editor de código html"
  },
  "html_editor_fb2ab713": {
    "message": "Editor HTML"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Obtive permissão para utilizar este ficheiro."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Sou o titular dos direitos de autor"
  },
  "icon_215a1dc6": {
    "message": "Ícone"
  },
  "icon_8168b2f8": {
    "message": "Ícone"
  },
  "icon_color_b86dd6d6": {
    "message": "Cor do Ícone"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Ícones do fabricante de ícones"
  },
  "icon_options_7e32746e": {
    "message": "Opções de Ícones"
  },
  "icon_options_tray_2b407977": {
    "message": "Bandeja de Opções de Ícones"
  },
  "icon_preview_1782a1d9": {
    "message": "Pré-visualização de Ícones"
  },
  "icon_shape_30b61e7": {
    "message": "Forma de Ícone"
  },
  "icon_size_9353edea": {
    "message": "Tamanho do Ícone"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Se for deixado em branco, o texto da ligação será apresentado como o nome da ligação à disciplina"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Se os Direitos de Utilização forem necessários, o ficheiro não será publicado até ser ativado na página Ficheiros."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Se você não selecionar os direitos de utilização agora, este ficheiro não será publicado apor seu carregamento."
  },
  "image_8ad06": {
    "message": "Imagem"
  },
  "image_c1c98202": {
    "message": "imagem"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Os nomes dos arquivos de imagem não devem ser usados como o atributo alt descrevendo o conteúdo da imagem."
  },
  "image_options_5412d02c": {
    "message": "Opções de imagem"
  },
  "image_options_tray_90a46006": {
    "message": "Bandeja de Opções de Imagem"
  },
  "image_to_crop_3a34487d": {
    "message": "Imagem a cortar"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Imagem com nome de ficheiro { file }"
  },
  "images_7ce26570": {
    "message": "Imagens"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "As imagens devem incluir um atributo alt descrevendo o conteúdo da imagem."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Porção imaginária (de número complexo)"
  },
  "in_element_of_19ca2f33": {
    "message": "Em (Elemento De)"
  },
  "increase_indent_6af90f7c": {
    "message": "Aumentar Avanço"
  },
  "increase_rich_content_area_340b775": {
    "message": "Aumentar área de conteúdo avançado"
  },
  "indefinite_integral_6623307e": {
    "message": "Integral Indefinido"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } de { max }"
  },
  "indigo_2035fc55": {
    "message": "Indigo"
  },
  "inference_fed5c960": {
    "message": "Inferência"
  },
  "infinity_7a10f206": {
    "message": "Infinito"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Campo de entrada para alfa"
  },
  "input_field_for_blue_561e020a": {
    "message": "Campo de entrada para azul"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Campo de entrada para verde"
  },
  "input_field_for_red_86a84615": {
    "message": "Campo de entrada para vermelho"
  },
  "insert_593145ef": {
    "message": "Inserir"
  },
  "insert_link_6dc23cae": {
    "message": "Inserir ligação"
  },
  "insert_math_equation_57c6e767": {
    "message": "Inserir Equação Matemática"
  },
  "integers_336344e1": {
    "message": "Inteiros"
  },
  "intersection_cd4590e4": {
    "message": "Intersecção"
  },
  "invalid_description_991e23bb": {
    "message": "Descrição inválida"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Entrada inválida."
  },
  "invalid_file_c11ba11": {
    "message": "Ficheiro inválido"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Tipo de ficheiro inválido"
  },
  "invalid_url_cbde79f": {
    "message": "URL inválido"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "Questão { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Itálico aplicado"
  },
  "italic_removed_17cbab6f": {
    "message": "Itálico removido"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (Variante)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Atalhos de teclado"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Os teclados navegam para ligações usando a tecla Tab. Dois links adjacentes que direcionam para o mesmo destino podem confundir os utilizadores de teclado."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Ícone das Artes Linguísticas"
  },
  "languages_icon_9d20539": {
    "message": "Ícone de Idiomas"
  },
  "large_9c5e80e7": {
    "message": "Ampla"
  },
  "large_text_e7ba08cd": {
    "message": "Texto Grande"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Grande ({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "Aprender"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Saiba mais sobre ligações adjacentes"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Saiba mais sobre o contraste de cores"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Saiba mais sobre como organizar títulos de página"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Saiba mais sobre a estrutura apropriada do cabeçalho da página"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Saiba mais sobre cabeçalhos de tabelas"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Saiba mais sobre como usar o texto alternativo para imagens"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Saiba mais sobre como usar legendas com tabelas"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Saiba mais sobre como usar nomes de ficheiros como texto alternativo"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Saiba mais sobre como usar listas"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Saiba mais sobre como usar atributos de escopo com tabelas"
  },
  "leave_as_is_4facfe55": {
    "message": "Deixe como está"
  },
  "left_3ea9d375": {
    "message": "Esquerda"
  },
  "left_align_43d95491": {
    "message": "Alinhamento à esquerda"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Suporte de ângulo esquerdo"
  },
  "left_arrow_4fde1a64": {
    "message": "Seta à esquerda"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Seta à esquerda com gancho"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Teto esquerdo"
  },
  "left_curly_brace_1726fb4": {
    "message": "Braço encaracolado à esquerda"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Seta Arpão para baixo à esquerda"
  },
  "left_floor_29ac2274": {
    "message": "Piso esquerdo"
  },
  "left_to_right_e9b4fd06": {
    "message": "Da esquerda para a direita"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Seta Arpão para cima à esquerda"
  },
  "leftward_arrow_1e4765de": {
    "message": "Seta à esquerda"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Triângulo Apontador à esquerda"
  },
  "less_than_a26c0641": {
    "message": "Menos do que"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Menos que ou Igual"
  },
  "library_icon_ae1e54cf": {
    "message": "Ícone da biblioteca"
  },
  "light_blue_5374f600": {
    "message": "Azul claro"
  },
  "link_7262adec": {
    "message": "Ligação"
  },
  "link_options_a16b758b": {
    "message": "Opções de Ligação"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "tipo de ligação: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Ligação com texto a começar com { start }"
  },
  "links_14b70841": {
    "message": "Links"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Ligações para um sitio externo"
  },
  "lists_cd1336fc": {
    "message": "Listas"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "As listas devem ser formatadas como listas."
  },
  "load_more_35d33c7": {
    "message": "Carregar mais"
  },
  "loading_25990131": {
    "message": "A carregar..."
  },
  "loading_bde52856": {
    "message": "A carregar"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "carregamento de legendas/subtítulos fechados falhou."
  },
  "loading_external_tool_d839042c": {
    "message": "Carregamento de ferramenta externa"
  },
  "loading_failed_b3524381": {
    "message": "A carregar falhou..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "O carregamento falhou."
  },
  "loading_folders_d8b5869e": {
    "message": "A carregar pastas"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Suporte de lugar de carregamento para { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "A carregar, por favor aguarde"
  },
  "loading_preview_9f077aa1": {
    "message": "Pré-visualização do carregamento"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Bloquear velocidade em 1x"
  },
  "locked_762f138b": {
    "message": "Bloqueado"
  },
  "logical_equivalence_76fca396": {
    "message": "Equivalência Lógica"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Equivalência Lógica (Curta)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Equivalência Lógica (curta e espessa)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Equivalência Lógica (Espessa)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Pontos Horizontais Baixos"
  },
  "magenta_4a65993c": {
    "message": "Magenta"
  },
  "maps_to_e5ef7382": {
    "message": "Mapas para"
  },
  "math_icon_ad4e9d03": {
    "message": "Ícone Matemática"
  },
  "media_af190855": {
    "message": "Mídia"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "O ficheiro multimédia está a ser processado. É favor, tentar novamente mais tarde."
  },
  "media_options_saved_560c4ec8": {
    "message": "Opções de multimédia guardadas."
  },
  "media_title_2112243b": {
    "message": "Título do Media"
  },
  "medium_5a8e9ead": {
    "message": "Médio"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Médio ({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "Criar ligações"
  },
  "mic_a7f3d311": {
    "message": "Mic"
  },
  "microphone_disabled_15c83130": {
    "message": "Microfone desabilitado"
  },
  "middle_27dc1d5": {
    "message": "Médio"
  },
  "minimize_file_preview_da911944": {
    "message": "Minimizar visualização de arquivo"
  },
  "minimize_video_20aa554b": {
    "message": "Minimizar vídeo"
  },
  "minus_fd961e2e": {
    "message": "Menos"
  },
  "minus_plus_3461f637": {
    "message": "Menos/Menos"
  },
  "misc_3b692ea7": {
    "message": "Diversos"
  },
  "miscellaneous_e9818229": {
    "message": "Diversos"
  },
  "module_90d9fd32": {
    "message": "Módulo"
  },
  "modules_c4325335": {
    "message": "Módulos"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Mover imagem para cortar { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Imagem Multi-Cor"
  },
  "multiplication_sign_15f95c22": {
    "message": "Sinal de Multiplicação"
  },
  "music_icon_4db5c972": {
    "message": "Ícone de música"
  },
  "my_files_2f621040": {
    "message": "Os meus ficheiros"
  },
  "n_th_root_9991a6e4": {
    "message": "Raiz N-th"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Nome"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Natural (Música)"
  },
  "natural_numbers_3da07060": {
    "message": "Números Naturais"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Navegue pelo menu ou barra de ferramentas"
  },
  "navigation_ee9af92d": {
    "message": "Navegação"
  },
  "nested_greater_than_d852e60d": {
    "message": "Aninhado Maior do que"
  },
  "nested_less_than_27d17e58": {
    "message": "Aninhado Menos do que"
  },
  "new_quiz_34aacba6": {
    "message": "Novo questionário"
  },
  "next_40e12421": {
    "message": "Próximo"
  },
  "next_findtext_9d69f0fe": {
    "message": "Seguinte { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Não foram detectados problemas de acessibilidade."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Ainda não foram criados anúncios."
  },
  "no_announcements_found_20185afc": {
    "message": "Não foram encontrados anúncios."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Ainda não foram criadas tarefas."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Não foram encontradas tarefas."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Nenhuma alteração a guardar."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Ainda não foram criadas discussões."
  },
  "no_discussions_found_9284063b": {
    "message": "Não foram encontradas discussões."
  },
  "no_e16d9132": {
    "message": "Não"
  },
  "no_file_chosen_9a880793": {
    "message": "Nenhum ficheiro escolhido"
  },
  "no_headers_9bc7dc7f": {
    "message": "Sem cabeçalho"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Ainda não foram criados módulos."
  },
  "no_modules_found_2df43a40": {
    "message": "Nenhum módulo encontrado."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Ainda não foram criadas páginas."
  },
  "no_pages_found_6799350": {
    "message": "Nenhuma página encontrada."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Não está disponível uma pré-visualização para este ficheiro."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Ainda não foram criados questionários."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Não foram encontrados questionários."
  },
  "no_results_940393cf": {
    "message": "Nenhum resultado."
  },
  "no_results_found_58717065": {
    "message": "Nenhum resultado encontrado"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Nenhum resultado encontrado para { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Nenhum vídeo"
  },
  "none_3b5e34d2": {
    "message": "Nenhum"
  },
  "none_selected_b93d56d2": {
    "message": "Nenhuma Selecionada"
  },
  "normal_text_7b03da48": {
    "message": "Texto normal"
  },
  "not_equal_6e2980e6": {
    "message": "Não Igual"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Não Em (Não Um Elemento De)"
  },
  "not_negation_1418ebb8": {
    "message": "Não (Negação)"
  },
  "not_subset_dc2b5e84": {
    "message": "Não Subconjunto"
  },
  "not_subset_strict_23d282bf": {
    "message": "Não Subconjunto (Estrito)"
  },
  "not_superset_5556b913": {
    "message": "Não Superconjunto"
  },
  "not_superset_strict_24e06f36": {
    "message": "Não Superconjunto (Estrito)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "Octógono"
  },
  "olive_6a3e4d6b": {
    "message": "Oliva"
  },
  "omega_8f2c3463": {
    "message": "Ómega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "Um dos seguintes estilos deve ser adicionado para guardar um ícone: Cor do Ícone, Tamanho do esboço, Texto do Ícone, ou Imagem"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Um ou mais ficheiros não foram colados. Tente carregar ou arrastar e largar ficheiros."
  },
  "open_circle_e9bd069": {
    "message": "Círculo Aberto"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Abrir esta caixa de diálogo de atalhos do teclado"
  },
  "open_title_application_fd624fc5": {
    "message": "Abrir aplicação { title }"
  },
  "operators_a2ef9a93": {
    "message": "Operadores"
  },
  "options_3ab0ea65": {
    "message": "Opções"
  },
  "or_9b70ccaa": {
    "message": "Ou"
  },
  "orange_81386a62": {
    "message": "Laranja"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Listas ordenadas e não ordenadas"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Outros atalhos de editor podem ser encontrados em"
  },
  "outline_color_3ef2cea7": {
    "message": "Cor do esboço"
  },
  "outline_size_a6059a21": {
    "message": "Tamanho do esboço"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } não é um protocolo válido."
  },
  "page_50c4823d": {
    "message": "Página"
  },
  "pages_e5414c2c": {
    "message": "Páginas"
  },
  "paragraph_5e5ad8eb": {
    "message": "Parágrafo"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Parágrafo aplicado"
  },
  "paragraph_removed_d09320e": {
    "message": "Parágrafo removido"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Parágrafo começando com { start }"
  },
  "parallel_d55d6e38": {
    "message": "Paralelo"
  },
  "partial_derivative_4a9159df": {
    "message": "Parcial (Derivado)"
  },
  "pass_1c19a2b3": {
    "message": "PASSAR"
  },
  "paste_5963d1c1": {
    "message": "Colar"
  },
  "pause_12af3bb4": {
    "message": "Pausa"
  },
  "pentagon_17d82ea3": {
    "message": "Pentágono"
  },
  "people_b4ebb13c": {
    "message": "Pessoas"
  },
  "percentage_34ab7c2c": {
    "message": "Porcentagem"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "A percentagem deve ser um número"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "A percentagem deve ser de, pelo menos { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Ícone das Artes Performativas"
  },
  "perpendicular_7c48ede4": {
    "message": "Perpendicular"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi (Variante)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Ícone de Educação Física"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (Variante)"
  },
  "pick_a_color_557abfb0": {
    "message": "Escolher uma cor"
  },
  "pink_68ad45cb": {
    "message": "Rosa"
  },
  "pixels_52ece7d1": {
    "message": "Pixels"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Os píxeis têm de ter pelo menos { width } x { height }px"
  },
  "play_1a47eaa7": {
    "message": "Reproduzir"
  },
  "play_media_comment_35257210": {
    "message": "Reproduzir comentário de mídia."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Reproduzir comentários de mídia { name } de { createdAt }."
  },
  "player_layout_14e09a29": {
    "message": "Disposição do jogador"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Por favor, permita que o Canvas aceda ao seu microfone e webcam."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Escolher um ficheiro"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Por favor insira um nome de ficheiro"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Insira um URL de vídeo válido de uma plataforma compatível."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Selecione um ficheiro de um tipo suportado"
  },
  "plus_d43cd4ec": {
    "message": "Mais"
  },
  "plus_minus_f8be2e83": {
    "message": "Mais/Menos"
  },
  "posted_when_a578f5ab": {
    "message": "Publicado: { when }"
  },
  "power_set_4f26f316": {
    "message": "Conjunto de energia"
  },
  "precedes_196b9aef": {
    "message": "Precede"
  },
  "precedes_equal_20701e84": {
    "message": "Precede Igual"
  },
  "preformatted_d0670862": {
    "message": "Pré-formatado"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Voltar"
  },
  "preview_53003fd2": {
    "message": "Visualização"
  },
  "preview_a3f8f854": {
    "message": "VISUALIZAÇÃO"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Pré-visualização em sobreposição"
  },
  "preview_inline_9787330": {
    "message": "Pré-visualização em linha"
  },
  "previous_bd2ac015": {
    "message": "Anterior"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Anterior { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Cores escolhidas anteriormente"
  },
  "prime_917ea60e": {
    "message": "Primo"
  },
  "prime_numbers_13464f61": {
    "message": "Números primos"
  },
  "product_39cf144f": {
    "message": "Produto"
  },
  "proportional_f02800cc": {
    "message": "Proporcional"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "O protocolo deve ser ftp, http, https, mailto, skype, tel ou pode ser omitido"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "Publicado"
  },
  "published_when_302d8e23": {
    "message": "Publicado: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Abóbora"
  },
  "purple_7678a9fc": {
    "message": "Violeta"
  },
  "quaternions_877024e0": {
    "message": "Quaternions"
  },
  "quiz_e0dcce8f": {
    "message": "Teste"
  },
  "quizzes_7e598f57": {
    "message": "Testes"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Números Racionais"
  },
  "real_numbers_7c99df94": {
    "message": "Números reais"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Porção real (de número complexo)"
  },
  "record_7c9448b": {
    "message": "Gravar"
  },
  "record_upload_media_5fdce166": {
    "message": "Gravar/Carregar Mídia"
  },
  "recording_98da6bda": {
    "message": "Gravação"
  },
  "red_8258edf3": {
    "message": "Encarnado"
  },
  "relationships_6602af70": {
    "message": "Relacionamentos"
  },
  "religion_icon_246e0be1": {
    "message": "Ícone Religião"
  },
  "remove_f47dc62a": {
    "message": "Eliminar"
  },
  "remove_filename_3ea029f6": {
    "message": "Remover { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Remova estilo de cabeçalho"
  },
  "remove_link_d1f2f4d0": {
    "message": "Remover ligação"
  },
  "replace_all_d3d68b3": {
    "message": "Substituir tudo"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Substituir tudo { findText } por { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Substituir"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Substituir { findText } por { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Substituir por"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Substituído { alertFindText } por { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Substituiu tudo { alertFindText } por { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Redefinir"
  },
  "resize_ec83d538": {
    "message": "Redimensionar"
  },
  "restore_auto_save_deccd84b": {
    "message": "Restaurar o auto-salvamento?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Resultado { index } de { max }."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Torniquete reverso (Não Rende)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (Variante)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Editor de conteúdo avançado"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Área de Rich Text. Prima { OSKey } +F8 para obter atalhos do Editor de Conteúdo Rico."
  },
  "right_71ffdc4d": {
    "message": "Direita"
  },
  "right_align_39e7a32a": {
    "message": "Alinhamento à direita"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Suporte de ângulo reto"
  },
  "right_arrow_35e0eddf": {
    "message": "Seta à direita"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Seta à direita com gancho"
  },
  "right_ceiling_839dc744": {
    "message": "Teto direito"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Braço encaracolado direito"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Seta Arpão para a Direita Inferior"
  },
  "right_floor_5392d5cf": {
    "message": "Andar Direito"
  },
  "right_to_left_9cfb092a": {
    "message": "Direita para a esquerda"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Seta Arpão Direito para cima"
  },
  "rightward_arrow_32932107": {
    "message": "Seta à direita"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Triângulo de Apontamento à Direita"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Rodar imagem -90 graus"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Rodar a imagem 90 graus"
  },
  "rotation_9699c538": {
    "message": "Rotação"
  },
  "row_fc0944a7": {
    "message": "Linha"
  },
  "row_group_979f5528": {
    "message": "Grupo de linhas"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Infelizmente, o editor de HTML bonito não está acessível através do teclado. Aceda aqui ao editor de HTML em bruto."
  },
  "save_11a80ec3": {
    "message": "Guardar"
  },
  "save_copy_ca63944e": {
    "message": "Guardar cópia"
  },
  "save_media_cb9e786e": {
    "message": "Guardar Mídia"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Ícones salvos do Criador de Ícones"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Os leitores de ecrã não podem determinar o que é exibido numa imagem sem texto alternativo, e os nomes dos ficheiros geralmente são sem sentido de sequências de números e letras que não descrevem o contexto ou o significado."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Os leitores de ecrã não podem determinar o que é exibido numa imagem sem texto alternativo, que descreve o conteúdo e o significado da imagem. O texto alternativo deve ser simples e conciso."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Os leitores de ecrã não podem determinar o que é exibido numa imagem sem texto alternativo, que descreve o conteúdo e o significado da imagem."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Os leitores de ecrã não podem interpretar tabelas sem a estrutura adequada. Os cabeçalhos de tabela fornecem escopo de direção e conteúdo."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Os leitores de ecrã não podem interpretar tabelas sem a estrutura adequada. As legendas da tabela descrevem o contexto e a compreensão geral da tabela."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Os leitores de ecrã não podem interpretar tabelas sem a estrutura adequada. Cabeçalhos de tabela fornecem orientação e visão geral do conteúdo."
  },
  "script_l_42a7b254": {
    "message": "Roteiro L"
  },
  "search_280d00bd": {
    "message": "Pesquisar"
  },
  "select_audio_source_21043cd5": {
    "message": "Selecionar fonte de áudio"
  },
  "select_crop_shape_d441feeb": {
    "message": "Seleccionar cortar forma"
  },
  "select_language_7c93a900": {
    "message": "Selecione o idioma"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Selecionar fonte de vídeo"
  },
  "selected_274ce24f": {
    "message": "Selecionado"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Selecionado { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Seleção"
  },
  "set_header_scope_8c548f40": {
    "message": "Definir o alcance do cabeçalho"
  },
  "set_minus_b46e9b88": {
    "message": "Definir Menos"
  },
  "set_table_header_cfab13a0": {
    "message": "Definir cabeçalho da tabela"
  },
  "sharp_music_ab956814": {
    "message": "Afiada (Música)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+Setas"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Shift-O para abrir o editor de html bonito."
  },
  "shortcut_911d6255": {
    "message": "Atalho"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Mostrar opções de imagem"
  },
  "show_link_options_545338fd": {
    "message": "Mostrar opções de ligação"
  },
  "show_rolling_transcript_c1481744": {
    "message": "Mostrar transcrição contínua"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "Mostrar transcrição contínua"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Utilizadores vistos navegam nas páginas da Web rapidamente, procurando títulos em grande ou em negrito. Os utilizadores do leitor de ecrã dependem de cabeçalhos para a compreensão contextual. Os cabeçalhos devem usar a estrutura adequada."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Utilizadores vistos navegam nas páginas da Web rapidamente, procurando títulos em grande ou em negrito. Os utilizadores do leitor de ecrã dependem de cabeçalhos para a compreensão contextual. Os cabeçalhos devem ser concisos dentro da estrutura adequada."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (Variante)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Imagem a uma cor"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Cor da imagem a uma cor"
  },
  "size_b30e1077": {
    "message": "Tamanho"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "O tamanho do ficheiro de legendagem é maior do que o tamanho máximo de ficheiro { max } kb permitido."
  },
  "small_b070434a": {
    "message": "Pequeno"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Pequeno ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "Círculo Sólido"
  },
  "something_went_wrong_89195131": {
    "message": "Algo deu errado."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Algo deu errado ao aceder sua webcam."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Algo deu errado e eu não sei o que mostrar."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Algo deu errado. Verifique a sua ligação, recarregue a página, e tente novamente."
  },
  "something_went_wrong_d238c551": {
    "message": "Algo deu errado"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Algo correu mal ao partilhar seu ecrã."
  },
  "sort_by_e75f9e3e": {
    "message": "Classificar por"
  },
  "spades_suit_b37020c2": {
    "message": "Espadas (Fato)"
  },
  "square_511eb3b3": {
    "message": "Quadrado"
  },
  "square_cap_9ec88646": {
    "message": "Boné quadrado"
  },
  "square_cup_b0665113": {
    "message": "Taça quadrada"
  },
  "square_root_e8bcbc60": {
    "message": "Raiz quadrada"
  },
  "square_root_symbol_d0898a53": {
    "message": "Símbolo Raiz quadrada"
  },
  "square_subset_17be67cb": {
    "message": "Subconjunto quadrado"
  },
  "square_subset_strict_7044e84f": {
    "message": "Subconjunto quadrado (Estrito)"
  },
  "square_superset_3be8dae1": {
    "message": "Subconjunto quadrado"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Subconjunto quadrado (Rigoroso)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "lista desordenada quadrada"
  },
  "star_8d156e09": {
    "message": "Marcar"
  },
  "start_over_f7552aa9": {
    "message": "Reiniciar"
  },
  "start_recording_9a65141a": {
    "message": "Iniciar gravação"
  },
  "steel_blue_14296f08": {
    "message": "Azul Aço"
  },
  "studio_media_options_ee504361": {
    "message": "Opções de mídia do Studio"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Tabuleiro de Opções do Media do Studio"
  },
  "styles_2aa721ef": {
    "message": "Estilos"
  },
  "submit_a3cc6859": {
    "message": "Submeter"
  },
  "submitting_b90fac62": {
    "message": "A enviar..."
  },
  "subscript_59744f96": {
    "message": "Assinatura"
  },
  "subset_19c1a92f": {
    "message": "Subconjunto"
  },
  "subset_strict_8d8948d6": {
    "message": "Subconjunto (Estrito)"
  },
  "succeeds_9cc31be9": {
    "message": "Sucesso"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Sucesso igual"
  },
  "sum_b0842d31": {
    "message": "Soma"
  },
  "superscript_8cb349a2": {
    "message": "Superescrito"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Super-escrito e Assinatura"
  },
  "superset_c4db8a7a": {
    "message": "Superconjunto"
  },
  "superset_strict_c77dd6d2": {
    "message": "Superconjunto (Estrito)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Tipos de ficheiros suportados: SRT ou WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Mudar para o Editor HTML bonito"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Mudar para o Editor HTML bruto"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Mudar para o editor html"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Mudar para o editor de texto rico"
  },
  "syllabus_f191f65b": {
    "message": "Programa"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Sistema de Áudio Permitido"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Sistema de Áudio desabilitado"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/Setas"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Cabeçalho da tabela começando com { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Tabela começando com { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Os cabeçalhos das tabelas devem especificar o escopo."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "As tabelas devem incluir uma legenda descrevendo o conteúdo da tabela."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "As tabelas devem incluir pelo menos um cabeçalho."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Palete"
  },
  "text_7f4593da": {
    "message": "Texto"
  },
  "text_background_color_16e61c3f": {
    "message": "Cor de fundo do texto"
  },
  "text_color_acf75eb6": {
    "message": "Cor do texto"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "O texto é difícil de ler sem contraste suficiente entre o texto e o fundo, especialmente para aqueles com baixa visão."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "O texto maior que 18pt (ou em negrito 14pt) deve exibir uma relação mínima de contraste de 3:1."
  },
  "text_optional_384f94f7": {
    "message": "Texto (opcional)"
  },
  "text_position_8df8c162": {
    "message": "Posição do texto"
  },
  "text_size_887c2f6": {
    "message": "Tamanho do texto"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "O texto menor que 18pt (ou em negrito 14pt) deve exibir uma relação de contraste mínima de 4.5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "A pré-visualização do documento está a ser processada. É favor, tentar novamente mais tarde."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "O primeiro título de uma página deve ser um H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "A altura da área de conteúdo avançado é diminuída."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "A altura da área de conteúdo avançado é aumentada."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "O material é de domínio público"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "O material está sujeito a licença Creative Commons"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "O material está sujeito a uma exceção - por exemplo, uso justo, direito de cotação ou outros de acordo com as leis de direitos de autor aplicáveis"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "O editor de html bonito não é acessível por teclado. Prima Shift O para abrir o editor de html em bruto."
  },
  "therefore_d860e024": {
    "message": "Portanto"
  },
  "theta_ce2d2350": {
    "message": "Theta"
  },
  "theta_variant_fff6da6f": {
    "message": "Theta (Variante)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Seta espessa para baixo"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Seta à Esquerda Espessa"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Seta à Esquerda Espessa"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Seta à Direita espessa"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Seta à Direita Espessa"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Seta grossa para cima"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Não é possível visualizar este documento dentro do Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Não é possível reproduzir esta equação em Vista Básica."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Esta imagem está actualmente indisponível"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "Este vídeo pode exibir anúncios do YouTube."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Embora o seu vídeo tenha o título correto no navegador, não o atualizámos na base de dados."
  },
  "thumbnail_e0de666f": {
    "message": "Lista"
  },
  "timebar_a4d18443": {
    "message": "Barra de tempo"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "O título não pode ficar em branco"
  },
  "title_ee03d132": {
    "message": "Título"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "Para ser postado: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Tarefa: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Alternar grupo { summary }"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Alternar dica de ferramenta"
  },
  "tools_2fcf772e": {
    "message": "Ferramentas"
  },
  "top_66e0adb6": {
    "message": "Topo"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "O painel de transcrição está disponível em larguras superiores a 720 px."
  },
  "tray_839df38a": {
    "message": "Bandeja"
  },
  "triangle_6072304e": {
    "message": "Triângulo"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Torniquete (Rendimentos)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "digite Control F9 para acessar as opções de imagem. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "digite Control F9 para acessar as opções de ligação. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "digite Control F9 para acessar as opções da tabela. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Não é possível determinar o url de seleção de recursos"
  },
  "underline_applied_ae01ec97": {
    "message": "Sublinhado aplicado"
  },
  "underline_removed_3693e17c": {
    "message": "Sublinhado removido"
  },
  "union_e6b57a53": {
    "message": "União"
  },
  "unpublished_dfd8801": {
    "message": "Não publicado"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "As alterações não guardadas serão perdidas."
  },
  "untitled_16aa4f2b": {
    "message": "Sem título"
  },
  "untitled_efdc2d7d": {
    "message": "sem título"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Seta diagonal para cima e esquerda"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Seta diagonal para cima e direita"
  },
  "up_c553575d": {
    "message": "Para cima"
  },
  "updated_link_a827e441": {
    "message": "Ligação atualizada"
  },
  "upload_document_253f0478": {
    "message": "Carregar documento"
  },
  "upload_file_fd2361b8": {
    "message": "Carregar ficheiro"
  },
  "upload_image_6120b609": {
    "message": "Carregar imagem"
  },
  "upload_media_ce31135a": {
    "message": "Carregar Multimédia"
  },
  "upload_record_media_e4207d72": {
    "message": "Carregar/Gravar Mídia"
  },
  "uploading_19e8a4e7": {
    "message": "A realizar carregamento"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "lista ordenada por ordem alfabética maiúscula"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Delta em maiúsculas"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Gama em maiúsculas"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Lambda em maiúsculas"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Omega em maiúsculas"
  },
  "uppercase_phi_caa36724": {
    "message": "Phi em maiúsculas"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Pi em maiúsculas"
  },
  "uppercase_psi_6395acbe": {
    "message": "Psi em maiúsculas"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "lista ordenada por numeração Romana  maiúscula"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Sigma em maiúsculas"
  },
  "uppercase_theta_49afc891": {
    "message": "Teta em maiúsculas"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Upsilon em maiúsculas"
  },
  "uppercase_xi_341e8556": {
    "message": "Xi em maiúsculas"
  },
  "upsilon_33651634": {
    "message": "Upsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Seta Apontada para cima e para baixo"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Seta Apontada para cima e para baixo (espessa)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Seta para cima"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Triângulo Apontado para cima"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Direito de utilização:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Direito de utilização: (requerido)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Use as teclas de seta para navegar pelas opções."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Utilizar as teclas de setas para selecionar uma forma."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Utilizar as teclas de setas para selecionar um tamanho."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Utilizar as teclas de setas para selecionar uma posição de texto."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Utilizar as teclas de setas para selecionar um tamanho de texto."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Usar as teclas de setas para selecionar um tamanho de contorno."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Utilizado por leitores de ecrã para descrever o conteúdo de um { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Usado por leitores de tela para descrever o conteúdo de uma imagem"
  },
  "user_documents_c206e61f": {
    "message": "Documentos do utilizador"
  },
  "user_files_78e21703": {
    "message": "Ficheiros do utilizador"
  },
  "user_images_b6490852": {
    "message": "Imagens do utilizador"
  },
  "user_media_14fbf656": {
    "message": "Mídia do utilizador"
  },
  "vector_notation_cf6086ab": {
    "message": "Vetor (Notação)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Barra Vertical (Definir Notação do Construtor)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Pontos Verticais"
  },
  "video_options_24ef6e5d": {
    "message": "Opções de Vídeo"
  },
  "video_options_tray_3b9809a5": {
    "message": "Bandeja de Opções de Vídeo"
  },
  "video_player_b371005": {
    "message": "Reprodutor de vídeo"
  },
  "video_player_for_9e7d373b": {
    "message": "Leitor de vídeo para "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Leitor de vídeo para { title }"
  },
  "video_url_889d3263": {
    "message": "URL do vídeo"
  },
  "view_all_e13bf0a6": {
    "message": "Ver tudo"
  },
  "view_ba339f93": {
    "message": "Ver"
  },
  "view_description_30446afc": {
    "message": "Ver descrição"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Ver atalhos de teclado"
  },
  "view_title_description_67940918": {
    "message": "Ver descrição { title }"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Ver contagem de palavras e caracteres"
  },
  "viewer_restrictions_e14274c9": {
    "message": "Restrições do visualizador"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Não conseguimos detectar um microfone a funcionar ligado ao seu dispositivo."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Não conseguimos detectar uma webcam que funcionasse ligada ao seu dispositivo."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Não conseguimos detectar uma webcam ou microfone a funcionar ligado ao seu dispositivo."
  },
  "webcam_disabled_30c66986": {
    "message": "Cámara de vídeo desabilitada"
  },
  "webcam_fe91b20f": {
    "message": "Webcam"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "As páginas web devem ter apenas um único H1, que é automaticamente utilizado pelo título da página. O primeiro título do seu conteúdo deve ser um H2."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Quando a marcação é usada para formatar itens visualmente como uma lista, mas não indica o relacionamento da lista, os utilizadores podem ter dificuldade em navegar pelas informações."
  },
  "white_87fa64fd": {
    "message": "Branco"
  },
  "why_523b3d8c": {
    "message": "Por quê"
  },
  "width_492fec76": {
    "message": "Largura"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Largura e altura devem ser números"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "Página inicial do wiki"
  },
  "word_count_c77fe3a6": {
    "message": "Contagem de palavras"
  },
  "words_b448b7d5": {
    "message": "Palavras"
  },
  "wreath_product_200b38ef": {
    "message": "Produto da coroa de flores"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Sim"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Você está em uma paleta de cores. Para navegar na paleta para cima, para a esquerda, para baixo ou para a direita, utilize os botões ''W'', ''A'', ''S'' e ''D'', respetivamente"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Você está em um controle deslizante de cores. Para navegar para a esquerda ou para a direita, utilize os botões ''A'' e ''D'', respetivamente"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Você está em um controle deslizante alfa. Para navegar no seletor para a esquerda ou para a direita, utilize os botões ''A'' e ''D'', respetivamente"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Tem alterações não guardadas na bandeja do Criador de Ícones. Quer continuar sem guardar estas alterações?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Poderá ser necessário ajustar títulos adicionais para manter a hierarquia das páginas."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Não é possível carregar um ficheiro vazio."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "A sua imagem foi comprimida para Criador de Ícones. Imagens inferiores a { size } KB não serão comprimidas."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "O seu microfone está bloqueado nas definições do navegador."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "A sua webcam e microfone estão bloqueados nas definições do navegador."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "A sua webcam está bloqueada nas definições do navegador."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Sua webcam já pode estar em uso."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "URL incorporado do YouTube"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Ampliar a imagem"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Reduzir a imagem"
  }
};
formatMessage.addLocale({
  pt: locale
});